skrilla.controller('createMatchCtrl', function ($scope, searchService, modalService, cacheService, $stateParams, srefService) {
    $scope.sport = $stateParams.sport
    cacheService.registerObject("contestSport", $scope.sport);
    $scope.validate = {}

    $scope.match = {
        sport: $scope.sport,
        seasonId: $stateParams.seasonId,
        tournamentId: $stateParams.tournamentId
    }


    $scope.getFranchise = function (franchise) {
        cacheService.registerObject("sport", $scope.sport)
        modalService.openModal('views/selectFranchiseModal/selectFranchiseModal.html', true, 'lg', true, true)
            .then(selectedFranchise => {
                $scope[franchise] = selectedFranchise;
            })
    }

    $scope.save = function () {
        modalService.confirm("Are you sure you'd like to create this Match?", function () {
            $scope.match.homeFranchiseId = $scope.homeFranchise && $scope.homeFranchise.id;
            $scope.match.awayFranchiseId = $scope.awayFranchise && $scope.awayFranchise.id;
            searchService.post("matches", $scope.match, "Match Successfully created").then(function (response) {
                modalService.dismissAll();
                srefService.go("matchDetails", {id: response.data.id});
            });
        });
    }

});
